import type { FieldPermissionGrant, FormPermissionsStructure } from '../model/form-permissions.types';
import type { FieldAccessDefault, FillSubject } from '../model/types';

export interface FieldAccess {
  editable: boolean;
}

export type FieldAccessResolver = (fieldId: string) => FieldAccess;

function intersects(left: number[], right: number[]): boolean {
  const lookup = new Set(left);
  return right.some((id) => lookup.has(id));
}

function grantAllows(grant: FieldPermissionGrant, subject: FillSubject): boolean {
  return (
    intersects(grant.positionIds, subject.positionIds) ||
    intersects(grant.functionalActivityIds, subject.functionalActivityIds)
  );
}

export function resolveFieldAccess(
  permissions: FormPermissionsStructure | null,
  subject: FillSubject,
  defaultAccess: FieldAccessDefault = 'open',
): FieldAccessResolver {
  const grants = new Map<string, FieldPermissionGrant>();
  for (const grant of permissions?.fields ?? []) grants.set(grant.fieldId, grant);

  return (fieldId) => {
    const grant = grants.get(fieldId);
    if (!grant) return { editable: defaultAccess === 'open' };
    return { editable: grantAllows(grant, subject) };
  };
}
